import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CorrectiveMaintenanceService } from 'app/modules/corrective-maintenance/services/corrective-maintenance.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { CMStatus } from 'app/modules/corrective-maintenance/model/corrective-maintenance.model';
import module from "app/modules/corrective-maintenance/corrective-maintenance.module";

@Component({
  selector: 'app-cm-edit',
  templateUrl: './cm-edit.page.html',
  imports: module,
  standalone: true,
  styleUrls: ['./cm-edit.page.scss']
})
export class CmEditPage {
  public cmForm: FormGroup
  public initialFormValues: any;
  public wellStringName: string = ''
  public failEquipmentList: any[] = []
  public status = CMStatus;

  private cmId = this.route.snapshot.paramMap.get('id');
  private action = this.route.snapshot.paramMap.get('action');

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private cmServices: CorrectiveMaintenanceService,
    public location: Location,
  ) { }

  get isViewOnly() {
    return this.action == 'view' ? true : false;
  }

  get cmStatus() {
    return this.cmForm.get('status')?.value;
  }

  get cmSource() {
    return this.cmForm.get('source')?.value;
  }

  get wellString(){
    return this.cmForm.get('wellStringShortName')?.value;
  }

  ngOnInit() {
    this.cmForm = this.initializeForm()
    this.getFailEquipments()

    this.cmServices.getCMRecord(this.cmId).subscribe((res) => {
      this.cmForm.patchValue({
        id: this.cmId,
        wellStringId: res.data.wellStringId,
        wellStringShortName: res.data.stringShortName,
        wellStringLongName: res.data.stringLongName,
        fieldLongName: res.data.fieldLongName,
        fieldShortName: res.data.fieldLongName,
        platformLongName: res.data.platformLongName,
        platformShortName: res.data.platformShortName,
        source: res.data.source,
        failEquipment: res.data.failEquipment,
        failureDate: res.data.failureDate,
        problemReported: res.data.problemReported,
        detailDesc: res.data.detailDesc,
        forwardActionPlan: res.data.forwardActionPlan,
        updatedBy: res.data.updateBy,
        updatedDate: handleFormatDate(res.data.updateDate, false),
        remark: res.data.remark,
        approvedBy: res.data.approvedBy ?? '',
        approvedDate: handleFormatDate(res.data.approvedDate, false),
        rectifiedDate: handleFormatDate(res.data.rectifiedDate, false),
        status: res.data.status,
        riskRanking: res.data.riskRanking
      })

      this.initialFormValues = { ...this.cmForm.getRawValue() }

      if(this.cmSource == 'CDFT'){
        this.cmForm.get('failEquipment')?.disable();
        this.cmForm.get('failureDate')?.disable();
      }
    })
  }

  initializeForm() {
    return this.fb.group({
      id: this.cmId,
      wellStringId: '',
      wellStringShortName: [{ value: '', disabled: true }],
      wellStringLongName: [{ value: '', disabled: true }],
      fieldLongName: [{ value: '', disabled: true }],
      fieldShortName: [{ value: '', disabled: true }],
      platformLongName: [{ value: '', disabled: true }],
      platformShortName: [{ value: '', disabled: true }],
      source: [{ value: '', disabled: true }],
      failEquipment: [{ value: '', disabled: this.isViewOnly }],
      failureDate: [{ value: new Date().toISOString(), disabled: this.isViewOnly }],
      problemReported: [{ value: '', disabled: this.isViewOnly }, Validators.required],
      detailDesc: [{ value: '', disabled: this.isViewOnly }, Validators.required],
      forwardActionPlan: [{ value: '', disabled: this.isViewOnly }, Validators.required],
      updatedBy: [{ value: '', disabled: true }],
      updatedDate: [{ value: new Date().toISOString(), disabled: true }],
      remark: [{ value: '', disabled: this.isViewOnly }],
      approvedBy: [{ value: '', disabled: true }],
      approvedDate: [{ value: '', disabled: true }],
      dateRectified: [{ value: new Date().toISOString(), disabled: this.isViewOnly }],
      status: '',
      riskRanking: [{ value: '', disabled: true }]
    })
  }

  hasFormChanged(): boolean {
    return JSON.stringify(this.initialFormValues) !== JSON.stringify(this.cmForm.getRawValue());
  }

  updateCM() {
    this.cmServices.updateCM(this.cmForm.getRawValue()).subscribe(res => this.location.back())
  }

  updateCMStatus(status: CMStatus) {
    this.cmForm.patchValue({status : status})

    this.cmServices.updateCM(this.cmForm.getRawValue())
      .subscribe({
        next: (res) => {
          this.location.back()
        },
      });
    }

  private getFailEquipments() {
    this.cmServices.getFailEquipmentList().subscribe((res) => {
      this.failEquipmentList = res
    })
  }
}
